import request from '@/api/utils';

// eslint-disable-next-line import/prefer-default-export
export function getStatsMeasures(formdata = {}, method = 'post') {
  const url = '/api/common/statsMeasure';
  return request.Api(url, formdata, method);
}
